import React, { Component } from 'react';
import PropTypes from 'prop-types';

export class PropertyCheckBox extends Component {
  static propTypes = {
    check: PropTypes.bool,
    onChangeHandler: PropTypes.func,
    additionalClassName: PropTypes.string,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node
    ]).isRequired
  };

  state = {
    checked: this.props.check,
    initialValue: this.props.check
  };

  get isChecked () {
    return this.state.checked;
  }

  onChange = (checked) => {
    this.setState({ checked }, this.props.onChangeHandler ? this.props.onChangeHandler(checked) : '');
  };

  render () {
    const { additionalClassName } = this.props;

    if (this.props.children) {
      return (
        <div className={`${additionalClassName}`}
          onClick={(event) => {
            this.onChange(!this.state.checked);
          }}>
          { this.props.children }
        </div>
      );
    }
  }
}

export default PropertyCheckBox;
